import { Point } from './types';

export class GameObject {
    public position: Point;

    constructor() {
        this.position = { x: 0, y: 0 };
    }

    update(dt: number): void {}
}
